import { useEffect, useState } from "react";
import withLoader from "../../../../../components/layouts/WithLoader";
import ProductionOrderService from "../../../../../services/Production/ProductionOrderService";
import getCurrentUserId from "../../../../../reduxSaga/sagas/requests/currentUserId";
import DataTableAssemblyComponentsWorkOrder from "./DataTableAssemblyComponentsWorkOrder";
import DataTableAssemblyComponentsDechetsWorkOrder from "./DataTableAssemblyComponentsDechetsWorkOrder";
import uploadAndDownloadService from "../../../../../services/uploadAndDownloadFile";
import UtilsFormule from "../../../../../utils/UtilsFormule";

const WorkOrderDetails = ({ startLoading, stopLoading }) => {
  const [availableWorkOrders, setAvailableWorkOrders] = useState([]);
  const [productionOrder, setProductionOrder] = useState([]);
  const [workOrder, setWorkOrder] = useState();
  const [assemlblyComponentsWorkOrders, setAssemlblyComponentsWorkOrders] = useState([]);
  const [assemlblyComponentsDechetWorkOrders, setAssemlblyComponentsDechetWorkOrders] = useState([]);

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();


  useEffect(() => {
    startLoading();
    ProductionOrderService.getAllWorkOrdersDetailsByIdByPO(
      getCurrentUserId(),
      localStorage.getItem("idPO"),
      localStorage.getItem("idWorkOrder")
    )
      .then((response) => {
        console.log("response", response);
        if (response.data.success) {
          setAvailableWorkOrders(response.data.success);
          setWorkOrder(response.data.success[0]?.workOrder);
          setAssemlblyComponentsWorkOrders(response.data.success[0]?.assemlblyComponentsWorkOrders);
          setAssemlblyComponentsDechetWorkOrders(response.data.success[0]?.assemlblyComponentsDechetWorkOrders)
          setProductionOrder(response.data.productionOrder);
        } else {
          // setOpenErrorAlert(true);
          // setErrorAlertText("Erreur : pas de bons de travails");
        }
      })
      .catch((e) => {
        console.log("error", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  
  const testAvancement = () => {
    if (workOrder.work_order_state === "PENDING") {
      return <span className="badge bg-danger">en attente</span>;
    } else if (workOrder.work_order_state === "STARTED") {
      return <span className="badge bg-primary">en cours</span>;
    } else if (workOrder.work_order_state === "FINISHED") {
      return <span className="badge bg-success">terminé</span>;
    }
  };

  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch((error) => {
        // setOpenErrorAlert(true);
        // setErrorAlertText("Erreur : "+error);
      });
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
              <div class="card-body">
                  <div className="row">
                    {" "}
                    <div className="col-sm-9">
                      <h3 className="card-title">L'ordre de production : </h3>{" "}
                      {productionOrder && productionOrder.code}{" "}
                      {productionOrder && productionOrder.name}
                    </div>
                    <div className="col-sm-3">
                      Date limite :{" "}
                      {productionOrder && UtilsFormule.formatDateHours(productionOrder.scheduledDate)}
                    </div>
                  </div>
                </div>
                </div>
                <div class="card  mt-3">
                <div class="card-body">
                  <div className="row">
                  <div>
           <label> Produit: </label>
             {workOrder?.product.productCode}-
              {workOrder?.product.barcode}-{workOrder?.product.name} <br />
              <label> Quantité à produire : </label> {workOrder?.quantity}
              <br />
              <label> Quantité produite : </label> {workOrder?.quantityProduite}
              <br />
        <br/>
        <label>Les composants</label>
        <DataTableAssemblyComponentsWorkOrder listComponents={assemlblyComponentsWorkOrders}/>
        <label>Les déchets</label>
        <DataTableAssemblyComponentsDechetsWorkOrder listComponents={assemlblyComponentsDechetWorkOrders}/>

        <label>Les opérations</label>
        {/* <DataTableOperations listOperation={row.workOrder.operationDetails.operations}/> */}
         <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Operation</th>
                    <th>SETUP TIME (s)</th>
                    <th>transfert TIME (s)</th>
                    <th>Avancement</th>
                    <th>Guide</th>
                  </tr>
                </thead>
                <tbody>
                  {workOrder?.operationDetails && (
                    <tr>
                      <td>
                        {workOrder?.operationDetails.operation.code}-
                        {workOrder?.operationDetails.operation.name}
                      </td>
                      <td>{workOrder?.operationDetails.setupTime}</td>
                      <td>{workOrder?.operationDetails.transferTime}</td>

                      <td>{testAvancement()}</td>
                      <td>
                        {" "}
                        <button
                          style={{ width: 40 }}
                          class="btn bg-gray btn-sm "
                          disabled={
                            workOrder.operationDetails.operation.path === "any"
                          }
                          onClick={() =>
                            onShowFileInOtherWizndowHandler(
                              workOrder.operationDetails.operation.path
                            )
                          }
                        >
                          <i class="fas fa-eye"></i>
                        </button>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

      </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withLoader(WorkOrderDetails);
